export enum DilationEnum {
  NotDilated = 'Not Dilated',
  Dilated = 'Dilated',
}
